<template>
  <header class="flex items-center gap-8 px-8 pt-8">
    <!-- Logo (aligned above the sidebar) -->
    <router-link class="w-56 flex-none flex items-center" to="/dashboard">
      <img src="/reeltrack-orange.svg" alt="ReelTrack" class="h-16" />
    </router-link>

    <!-- Global search -->
    <form
      class="relative flex-1 max-w-3xl"
      role="search"
      autocomplete="off"
      @submit.prevent="submitSearch"
    >
      <input
        v-model="query"
        type="search"
        name="search"
        :aria-label="$t('search')"
        :placeholder="$t('search')"
        class="w-full rounded-md bg-primary-500 text-white border border-primary-400 placeholder:text-subtle placeholder:opacity-60 py-3 pl-4 pr-12 focus:border-highlight focus:ring-1 focus:ring-highlight"
      />
      <button
        type="submit"
        class="absolute inset-y-0 right-0 flex items-center pr-4 text-muted hover:text-highlight"
        :aria-label="$t('search')"
      >
        <Font-awesome-icon :icon="['fas', 'search']" />
      </button>
    </form>

    <!-- Profile cluster -->
    <div class="flex items-center gap-6 ml-auto">
      <!-- Notifications -->
      <button
        type="button"
        class="relative flex h-11 w-11 items-center justify-center rounded-md text-muted hover:text-highlight"
        :aria-label="$t('notifications')"
      >
        <Font-awesome-icon :icon="['far', 'bell']" size="lg" />
        <span
          v-if="notifications > 0"
          class="absolute -top-2 -right-2 flex h-4 w-4 items-center justify-center rounded-full bg-highlight text-primary-700 text-[10px] font-semibold"
        >
          {{ notifications }}
        </span>
      </button>

      <!-- Avatar menu: profile, settings, sign out -->
      <UserMenu />
    </div>
  </header>
</template>

<script>
import { ViewName } from "@/router";
import UserMenu from "@/components/navigation/UserMenu.vue";

export default {
  name: "NavigationTopbar",
  components: { UserMenu },

  data() {
    return {
      query: "",
      // No notifications backend yet; badge shows only when > 0.
      notifications: 0,
    };
  },

  methods: {
    submitSearch() {
      const q = this.query.trim();
      if (!q) return;
      this.$router
        .push({ name: ViewName.Explore, query: { q } })
        .catch(() => undefined);
    },
  },
};
</script>
